var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-transaction"},[(_vm.isLoading)?_c('Loading'):_c('div',[(_vm.view)?_c('NissinView',{attrs:{"profile":_vm.profile},on:{"showLoading":_vm.showLoading,"hideLoading":_vm.hideLoading}}):_c('DefaultView',{attrs:{"profile":_vm.profile},on:{"showLoading":_vm.showLoading,"hideLoading":_vm.hideLoading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }